module.exports = new __parcel__URL__("Mkt Plan Hover.eec8532b.svg").toString();